import { render, staticRenderFns } from "./EmpCommunication.vue?vue&type=template&id=3d4cf791&"
import script from "./EmpCommunication.vue?vue&type=script&lang=js&"
export * from "./EmpCommunication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports